// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/es7.map.from.js
// module id = ./node_modules/babel-polyfill/node_modules/core-js/modules/es7.map.from.js
// module chunks = 4